import { useState, useEffect, FC } from "react";
import { GenericStorylineElementsList } from "../GeneralComponents/generic-storyline-list";
import Paginator from "../GeneralComponents/paginator";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import { Button, CircularProgress, Paper, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { StoryElement } from "./story-element";
import { StoryElementArchiveDisplay } from "./archive-display";



export function ManualArchiveManagement(){

    let [pageNumber, setPageNumber] = useState(0);
    let [storyElementsCount, setStoryElementsCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    function updateList(){
        StorylineServerProxy.getStoryElementsCount().then(count => {  setStoryElementsCount(count.count) });
        StorylineServerProxy.getStoryElements(pageSize, pageNumber).then(elements => { setStoryElements(elements) });
    }

    let [storyElements, setStoryElements] = useState([] as any[]);

    useEffect(() => {
        updateList();
    }, [pageNumber, pageSize]);


    return (
        <>
            <Paginator
                pageNumber={pageNumber}
                pageSize={pageSize}
                itemsCount={storyElementsCount}
                itemType={"story elements"}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
            /> 

            <GenericStorylineElementsList storyElements={storyElements} Component={StoryElementArchiveDisplay} updateListFromServer={updateList} /> 
        </>
    )
}